export enum DataExtractionIntervalType {
  none = 0,
  fixedRange = 1,
  incremental = 2,
  retroactive = 3
}
